
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/exposure",
      function () {
        return require("private-next-pages/news/exposure.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/exposure"])
      });
    }
  